import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import {
  FiActivity,
  FiArrowRight,
  FiCalendar,
  FiCheckCircle,
  FiClipboard,
  FiClock,
  FiFileText,
  FiMessageSquare,
  FiMic,
  FiPackage,
  FiRefreshCw,
  FiShield,
  FiTrendingUp,
  FiUsers,
} from 'react-icons/fi';
import { SiWhatsapp } from 'react-icons/si';
import api from '../utils/api';
import '../styles/landing-trix.css';

const soluciones = [
  {
    icon: FiCalendar,
    titulo: 'Clientes y ventas',
    texto: 'Gestiona clientes, agenda, presupuestos y seguimiento comercial desde un único lugar, con recordatorios y comunicación automática.',
  },
  {
    icon: FiMessageSquare,
    titulo: 'Emails y firma digital',
    texto: 'Envía correos desde la operación, adjunta documentos y firma digitalmente presupuestos y facturas sin depender de herramientas externas.',
  },
  {
    icon: FiPackage,
    titulo: 'Operación y personal',
    texto: 'Fichajes, tareas, almacén, alertas y métricas para controlar el equipo y la ejecución de cada trabajo sin perder el pulso del negocio.',
  },
];

const sectores = [
  'Electricistas',
  'Albañiles',
  'Carpintería aluminio / PVC y madera',
  'Pladur',
  'Desatascos y fontanería de urgencia',
  'Técnicos de climatización',
  'Jardinería y paisajismo',
  'Instaladores de cocinas y baños',
  'Pintores y decoradores',
  'Domótica, alarmas y CCTV',
  'Piscinas (construcción y mantenimiento)',
  'Talleres mecánicos y servicios',
  'Chapa y pintura de vehículos',
];

const modulos = [
  { titulo: 'Clientes', texto: 'CRM con historial, seguimiento y oportunidad comercial', precio: 'desde 29 €/mes' },
  { titulo: 'Agenda', texto: 'Citas, reservas, recordatorios y coordinación del equipo', precio: 'desde 39 €/mes' },
  { titulo: 'Presupuestos', texto: 'Creación, validación y seguimiento con firma digital', precio: 'desde 49 €/mes' },
  { titulo: 'Facturas', texto: 'Factura, cobro y trazabilidad legal con documentos firmados', precio: 'desde 59 €/mes' },
  { titulo: 'Emails', texto: 'Envío de correos automáticos, seguimiento y comunicaciones', precio: 'desde 29 €/mes' },
  { titulo: 'Operación', texto: 'Tareas, fichajes, turnos y vacaciones con control real', precio: 'desde 39 €/mes' },
  { titulo: 'Control', texto: 'Almacén, alertas y KPIs para tomar decisiones en tiempo real', precio: 'desde 49 €/mes' },
];

const CTA_BUTTON_TEXT = 'Solicita tu demo';

const flujoVoz = [
  {
    titulo: '1. Crea el cliente con voz',
    frase: '“Añade a Javier López, calle Mayor 12, y guarda su visita de reforma.”',
    detalle: 'Se completa el cliente, la dirección y el historial de contacto en segundos.',
    mockup: {
      label: 'Cliente',
      headline: 'Javier López',
      chips: ['Cliente', 'Visita', 'Contacto'],
      rows: [
        { key: 'Servicio', value: 'Reforma de baño' },
        { key: 'Dirección', value: 'Calle Mayor 12' },
        { key: 'Teléfono', value: '600 123 456' },
      ],
    },
  },
  {
    titulo: '2. Genera el presupuesto en segundos',
    frase: '“Crea un presupuesto para obra de baño con 2.300 € y 7 días.”',
    detalle: 'Trix transforma la voz en líneas, materiales, importe y plazo sin perder contexto.',
    mockup: {
      label: 'Presupuesto',
      headline: 'Obra de baño',
      chips: ['Materiales', 'Importe', 'Plazo'],
      rows: [
        { key: 'Total', value: '2.300 €' },
        { key: 'Línea', value: 'Pintura + azulejos' },
        { key: 'Entrega', value: '7 días' },
      ],
    },
  },
  {
    titulo: '3. Envía y factura sin salir del móvil',
    frase: '“Envíale presupuesto a Javier y factura esta obra.”',
    detalle: 'La gestión se cierra con el mismo flujo: oferta, envío, validación y factura legal.',
    mockup: {
      label: 'Factura',
      headline: 'Factura emitida',
      chips: ['Enviar', 'Cobro', 'Verifactu'],
      rows: [
        { key: 'Cliente', value: 'Javier López' },
        { key: 'Estado', value: 'Validada' },
        { key: 'Canal', value: 'WhatsApp' },
      ],
    },
  },
  {
    titulo: '4. Revisa stock y recibe alerta por Slack',
    frase: '“Factura la obra y descuenta stock de pintura y azulejos.”',
    detalle: 'Cuando se descuenta inventario y apunta a pocas unidades, Trix avisa por Slack para que el equipo reordene antes de quedarse sin material.',
    mockup: {
      label: 'Stock',
      headline: 'Aviso de stock bajo',
      chips: ['Pintura', 'Azulejos', 'Slack'],
      rows: [
        { key: 'Pintura interior', value: '2 uds.' },
        { key: 'Azulejos', value: '4 uds.' },
        { key: 'Acción', value: 'Pedido sugerido' },
      ],
      alert: 'Quedan pocas unidades. Revisa el pedido antes del próximo cierre.',
      slackMessage: {
        channel: '#operaciones',
        author: 'Trix · stock',
        text: '⚠️ Stock bajo: pintura interior quedan 2 uds. y azulejos 4 uds. Revisa el pedido antes del cierre.',
      },
    },
  },
];

export default function LandingTrixPublica() {
  const [form, setForm] = useState({ nombre: '', email: '', telefono: '', empresa: '', notas: '' });
  const [enviando, setEnviando] = useState(false);
  const [estado, setEstado] = useState({ tipo: '', mensaje: '' });
  const [slideActual, setSlideActual] = useState(0);
  const [modalAbierto, setModalAbierto] = useState(false);

  const handleChange = (event) => {
    setForm((prev) => ({ ...prev, [event.target.name]: event.target.value }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setEnviando(true);
    setEstado({ tipo: '', mensaje: '' });

    try {
      const { data } = await api.post('/empresas/publico/registro', { ...form, origen: 'landing-trix' });
      setEstado({ tipo: 'ok', mensaje: data?.mensaje || 'Gracias. Hemos recibido tu solicitud y te contactaremos para preparar la demo.' });
      setForm({ nombre: '', email: '', telefono: '', empresa: '', notas: '' });
      setModalAbierto(false);
    } catch (error) {
      setEstado({ tipo: 'error', mensaje: error?.response?.data?.error || 'No hemos podido enviar la solicitud. Inténtalo de nuevo en unos minutos.' });
    } finally {
      setEnviando(false);
    }
  };

  const abrirModal = () => {
    setEstado({ tipo: '', mensaje: '' });
    setModalAbierto(true);
  };

  useEffect(() => {
    const timer = setInterval(() => {
      setSlideActual((prev) => (prev + 1) % flujoVoz.length);
    }, 4500);

    return () => clearInterval(timer);
  }, []);

  const flujoActual = flujoVoz[slideActual];

  return (
    <div className="trix-landing">
      {modalAbierto && (
        <div className="landing-demo-overlay" style={{ position: 'fixed', inset: 0, background: 'rgba(15, 23, 42, 0.55)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 2000, padding: 20 }}>
          <div className="landing-demo-modal" role="dialog" aria-modal="true" aria-label={CTA_BUTTON_TEXT} style={{ width: '100%', maxWidth: 560, background: '#fff', borderRadius: 20, boxShadow: '0 24px 60px rgba(15, 23, 42, 0.28)', padding: 24 }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 16, marginBottom: 18 }}>
              <div>
                <div style={{ fontSize: 12, textTransform: 'uppercase', letterSpacing: '0.12em', color: '#6366f1', fontWeight: 800 }}>Contacto</div>
                <h3 style={{ margin: '8px 0 0', fontSize: 28, color: '#0f172a' }}>{CTA_BUTTON_TEXT}</h3>
              </div>
              <button type="button" aria-label="Cerrar modal" onClick={() => setModalAbierto(false)} style={{ border: 'none', background: '#f1f5f9', color: '#0f172a', width: 36, height: 36, borderRadius: 999, fontSize: 22, cursor: 'pointer' }}>×</button>
            </div>

            <form onSubmit={handleSubmit} style={{ display: 'grid', gap: 14 }}>
              <label style={{ display: 'grid', gap: 8 }}>
                <span style={{ fontWeight: 700, color: '#0f172a' }}>Nombre *</span>
                <input type="text" required name="nombre" value={form.nombre} onChange={handleChange} placeholder="Tu nombre" style={{ border: '1px solid #dfe7f5', borderRadius: 10, padding: '12px 14px', fontSize: 15 }} />
              </label>

              <label style={{ display: 'grid', gap: 8 }}>
                <span style={{ fontWeight: 700, color: '#0f172a' }}>Email *</span>
                <input type="email" required name="email" value={form.email} onChange={handleChange} placeholder="tuemail@empresa.com" style={{ border: '1px solid #dfe7f5', borderRadius: 10, padding: '12px 14px', fontSize: 15 }} />
              </label>

              <div className="landing-demo-fields" style={{ display: 'grid', gap: 14 }}>
                <label style={{ display: 'grid', gap: 8 }}>
                  <span style={{ fontWeight: 700, color: '#0f172a' }}>Teléfono</span>
                  <input type="tel" name="telefono" value={form.telefono} onChange={handleChange} placeholder="600 123 456" style={{ border: '1px solid #dfe7f5', borderRadius: 10, padding: '12px 14px', fontSize: 15 }} />
                </label>

                <label style={{ display: 'grid', gap: 8 }}>
                  <span style={{ fontWeight: 700, color: '#0f172a' }}>Empresa</span>
                  <input type="text" name="empresa" value={form.empresa} onChange={handleChange} placeholder="Nombre de tu empresa" style={{ border: '1px solid #dfe7f5', borderRadius: 10, padding: '12px 14px', fontSize: 15 }} />
                </label>
              </div>

              <label style={{ display: 'grid', gap: 8 }}>
                <span style={{ fontWeight: 700, color: '#0f172a' }}>Notas</span>
                <textarea name="notas" value={form.notas} onChange={handleChange} rows={4} placeholder="Cuéntanos qué necesitas o qué problema quieres resolver" style={{ border: '1px solid #dfe7f5', borderRadius: 10, padding: '12px 14px', fontSize: 15, resize: 'vertical' }} />
              </label>

              {estado.mensaje ? (
                <div style={{ borderRadius: 10, padding: '10px 12px', fontSize: 14, background: estado.tipo === 'ok' ? '#ecfdf5' : '#fef2f2', color: estado.tipo === 'ok' ? '#166534' : '#991b1b', border: `1px solid ${estado.tipo === 'ok' ? '#bbf7d0' : '#fecaca'}` }}>
                  {estado.mensaje}
                </div>
              ) : null}

              <div className="landing-demo-actions" style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'flex-end', gap: 10, marginTop: 6 }}>
                <a href="https://wa.me/34624080371" target="_blank" rel="noopener noreferrer" style={{ display: 'inline-flex', alignItems: 'center', gap: 8, background: '#166534', color: '#fff', borderRadius: 10, padding: '11px 16px', fontWeight: 700, textDecoration: 'none' }}>
                  <SiWhatsapp aria-hidden="true" />
                  Contactar por Whatsapp
                </a>
                <button type="button" onClick={() => setModalAbierto(false)} style={{ border: '1px solid #cbd5e1', background: '#fff', color: '#0f172a', borderRadius: 10, padding: '11px 16px', fontWeight: 700, cursor: 'pointer' }}>
                  Cancelar
                </button>
                <button type="submit" disabled={enviando} style={{ border: 'none', background: 'linear-gradient(135deg, #4f46e5, #7c3aed)', color: '#fff', borderRadius: 10, padding: '11px 18px', fontWeight: 800, cursor: 'pointer', opacity: enviando ? 0.8 : 1 }}>
                  {enviando ? 'Enviando…' : 'Enviar solicitud'}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      <header className="landing-header">
        <div className="landing-container landing-nav">
          <Link className="landing-brand" to="/" aria-label="Trix, inicio">
            <span className="landing-brand-mark" aria-hidden="true">T</span>
            <span className="landing-brand-word">TRIX</span>
          </Link>
          <nav className="landing-links" aria-label="Navegación principal">
            <a href="#soluciones">Soluciones</a>
            <a href="#plataforma">Plataforma</a>
            <a href="#demo">Solicita tu demo</a>
          </nav>
          <div className="landing-nav-actions">
            <Link className="landing-login" to="/login">Acceder</Link>
            <button type="button" className="landing-button landing-button-small" onClick={abrirModal}>
              {CTA_BUTTON_TEXT} <FiArrowRight aria-hidden="true" />
            </button>
          </div>
        </div>
      </header>

      <main>
        <section className="landing-hero">
          <div className="landing-container landing-hero-grid">
            <div className="landing-hero-copy">
              <p className="landing-eyebrow"><span aria-hidden="true" /> Tu negocio más ordenado, más rentable y más fácil de gestionar</p>
              <h1>Centraliza clientes, facturas, comunicaciones y firma digital en una sola plataforma.</h1>
              <p className="landing-lead">
                TRIX ayuda a tu equipo a gestionar clientes, presupuestos, facturas, emails, fichajes y tareas sin fragmentar la operación ni perder tiempo en procesos manuales.
              </p>
              <div className="landing-hero-actions">
                <button type="button" className="landing-button" onClick={abrirModal}>
                  {CTA_BUTTON_TEXT} <FiArrowRight aria-hidden="true" />
                </button>
                <a className="landing-text-link" href="#plataforma">Ver qué puedes gestionar <FiArrowRight aria-hidden="true" /></a>
              </div>
              <p className="landing-reassurance"><FiCheckCircle aria-hidden="true" /> Sin largas implantaciones: empieza en 15 minutos.</p>
            </div>

            <section className="landing-dashboard" aria-label="Vista previa del panel de control de Trix">
              <div className="dashboard-topbar">
                <div className="dashboard-topbar-left">
                  <span className="dashboard-kicker">Resumen de hoy</span>
                  <strong>Buenos días, Ana</strong>
                </div>
                <div className="dashboard-topbar-actions">
                  <span className="dashboard-search">Buscar</span>
                  <span className="dashboard-avatar">AG</span>
                </div>
              </div>
              <div className="dashboard-content">
                <div className="dashboard-summary">
                  <div>
                    <span>Martes, 18 de junio</span>
                    <h2>Tu operación, al día</h2>
                  </div>
                  <button type="button" className="dashboard-action">+ Nuevo cliente</button>
                </div>

                <div className="dashboard-stats">
                  <div className="dashboard-stat"><FiUsers aria-hidden="true" /><strong>26</strong><span>clientes</span></div>
                  <div className="dashboard-stat"><FiFileText aria-hidden="true" /><strong>12</strong><span>presupuestos</span></div>
                  <div className="dashboard-stat dashboard-stat-primary"><FiTrendingUp aria-hidden="true" /><strong>8.4k€</strong><span>facturado</span></div>
                </div>

                <div className="dashboard-panel-grid">
                  <div className="dashboard-panel">
                    <div className="dashboard-panel-head"><strong>Agenda</strong><span>Ver día</span></div>
                    <div className="dashboard-appointment"><b>09:30</b><span><strong>Revisión anual</strong><small>María López · Seat León</small></span><i>Confirmada</i></div>
                    <div className="dashboard-appointment"><b>11:00</b><span><strong>Entrega de pedido</strong><small>Distribuciones Norte</small></span><i>En curso</i></div>
                    <div className="dashboard-appointment"><b>15:00</b><span><strong>Visita obra</strong><small>Javier Ruiz · Reformas</small></span><i>Por llegar</i></div>
                  </div>

                  <div className="dashboard-panel dashboard-panel-side">
                    <div className="dashboard-panel-head"><strong>Alertas</strong><span>Hoy</span></div>
                    <div className="dashboard-alert dashboard-alert-warning">
                      <span className="dashboard-alert-dot">!</span>
                      <div>
                        <strong>Stock bajo</strong>
                        <small>Pintura interior · 2 uds.</small>
                      </div>
                    </div>
                    <div className="dashboard-alert">
                      <span className="dashboard-alert-dot dashboard-alert-dot-blue">✓</span>
                      <div>
                        <strong>Factura enviada</strong>
                        <small>5 clientes recibieron su factura</small>
                      </div>
                    </div>
                    <div className="dashboard-alert">
                      <span className="dashboard-alert-dot dashboard-alert-dot-blue">↗</span>
                      <div>
                        <strong>Presupuesto listo</strong>
                        <small>3 propuestas sin responder</small>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </section>

        <section className="landing-section landing-operacion-box">
          <div className="landing-container">
            <h2>Tu negocio, sin papeles y en un móvil.</h2>
            <div className="landing-operacion-grid">
              <div className="landing-operacion-item">
                <FiFileText aria-hidden="true" />
                <p>Presupuestos por voz, fichaje en un clic</p>
              </div>
              <div className="landing-operacion-item">
                <FiCheckCircle aria-hidden="true" />
                <p>VeriFactu incluido, sin líos con Hacienda</p>
              </div>
              <div className="landing-operacion-item">
                <FiPackage aria-hidden="true" />
                <p>Ni piezas ni material que falten</p>
              </div>
              <div className="landing-operacion-item">
                <FiRefreshCw aria-hidden="true" />
                <p>Sin permanencia, cancela cuando quieras</p>
              </div>
            </div>
          </div>
        </section>

        <section className="landing-flow" aria-label="Flujo de trabajo con voz de Trix">
          <div className="landing-container landing-flow-shell">
            <div className="landing-section-heading landing-flow-heading">
              <p className="landing-eyebrow">Así funciona en la práctica</p>
              <h2>Un flujo rápido de voz, cliente y presupuesto con pantallas reales.</h2>
            </div>
            <div className="landing-flow-grid">
              <div className="landing-flow-copy">
                <div className="landing-flow-voice-badge"><FiMic aria-hidden="true" /> Voz activa</div>
                <h3>{flujoActual.titulo}</h3>
                <p className="landing-flow-quote">{flujoActual.frase}</p>
                <p className="landing-flow-detail">{flujoActual.detalle}</p>
                <div className="landing-flow-nav" aria-label="Navegación del flujo de voz">
                  {flujoVoz.map((paso, index) => (
                    <button
                      key={paso.titulo}
                      className={index === slideActual ? 'landing-flow-dot active' : 'landing-flow-dot'}
                      type="button"
                      onClick={() => setSlideActual(index)}
                      aria-label={`Ver paso ${index + 1}`}
                    />
                  ))}
                </div>
              </div>

              <div className="landing-flow-card" aria-live="polite">
                <div className="landing-flow-card-top">
                  <span className="landing-flow-micro"><FiMic aria-hidden="true" /></span>
                  <span className="landing-flow-status">Escuchando…</span>
                </div>

                <div className="landing-flow-fakewindow">
                  <div className="landing-flow-window-bar">
                    <div className="landing-flow-window-dots" aria-hidden="true">
                      <span className="dot red" />
                      <span className="dot amber" />
                      <span className="dot green" />
                    </div>
                    <span className="landing-flow-window-label">{flujoActual.mockup.label}</span>
                  </div>

                  <div className="landing-flow-window-body">
                    <div className="landing-flow-window-header">
                      <div>
                        <small>{flujoActual.mockup.label}</small>
                        <strong>{flujoActual.mockup.headline}</strong>
                      </div>
                      <button type="button">Guardar</button>
                    </div>

                    <div className="landing-flow-window-pills">
                      {flujoActual.mockup.chips.map((chip) => (
                        <span key={chip}>{chip}</span>
                      ))}
                    </div>

                    <div className="landing-flow-window-list">
                      {flujoActual.mockup.rows.map((fila) => (
                        <div key={fila.key} className="landing-flow-window-row">
                          <span>{fila.key}</span>
                          <strong>{fila.value}</strong>
                        </div>
                      ))}
                    </div>

                    {flujoActual.mockup.alert ? (
                      <div className="landing-flow-window-alert">
                        <FiActivity aria-hidden="true" />
                        <span>{flujoActual.mockup.alert}</span>
                      </div>
                    ) : null}

                    {flujoActual.mockup.slackMessage ? (
                      <div className="landing-flow-window-slack" aria-label="Notificación simulada de Slack por stock bajo">
                        <div className="landing-flow-slack-header">
                          <span className="landing-flow-slack-badge">Slack</span>
                          <span>{flujoActual.mockup.slackMessage.channel}</span>
                        </div>
                        <div className="landing-flow-slack-message">
                          <span className="landing-flow-slack-avatar">T</span>
                          <div>
                            <strong>{flujoActual.mockup.slackMessage.author}</strong>
                            <p>{flujoActual.mockup.slackMessage.text}</p>
                          </div>
                        </div>
                      </div>
                    ) : null}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="landing-proof" aria-label="Ventajas de Trix">
         <div className="landing-container landing-proof-grid">
           <p><FiClock aria-hidden="true" /><span><strong>Tu negocio, sin papeles y en un móvil.</strong> Fichaje digital y legal.</span></p>
           <p><FiUsers aria-hidden="true" /><span><strong>Cumplimos con Verifactu.</strong> Facturación y trazabilidad al día.</span></p>
           <p><FiShield aria-hidden="true" /><span><strong>De la medición al presupuesto.</strong> Tu empresa, sin sorpresas ni piezas ni material que faltan.</span></p>
          </div>
        </section>

        <section id="soluciones" className="landing-section">
          <div className="landing-container">
            <div className="landing-section-heading">
              <p className="landing-eyebrow">Diseñado para el día a día</p>
              <h2>Más control para cada trabajo. Menos caos para cada día.</h2>
              <p>No es otro panel que alimentar. Es un espacio de trabajo que ordena clientes, tareas, presupuestos y seguimiento sin que nada se te escape.</p>
            </div>
            <div className="landing-solution-grid">
              {soluciones.map((solucion) => {
                const Icono = solucion.icon;
                return (
                  <article className="landing-solution-card" key={solucion.titulo}>
                    <span className="landing-card-icon"><Icono aria-hidden="true" /></span>
                    <h3>{solucion.titulo}</h3>
                    <p>{solucion.texto}</p>
                  </article>
                );
              })}
            </div>
           <div className="landing-sector-box">
             <p className="landing-sector-title">Especializados para negocios de obra, servicio y mantenimiento</p>
             <div className="landing-sector-list" aria-label="Sectores de clientes">
               {sectores.map((sector) => (
                 <span className="landing-sector-pill" key={sector}>{sector}</span>
               ))}
             </div>
           </div>
           <div className="landing-cta-inline">
             <p>Más orden, menos llamadas perdidas y más ventas con el mismo equipo.</p>
             <a href="#demo" className="landing-button landing-button-small">Solicita tu demo</a>
           </div>
         </div>
        </section>

        <section id="plataforma" className="landing-section landing-platform-section">
         <div className="landing-container landing-platform-grid">
           <div className="landing-platform-copy">
             <p className="landing-eyebrow">Una sola vista de trabajo</p>
             <h2>Todo lo que necesitas para operar mejor, desde un único sitio.</h2>
             <p>Organiza clientes, trabajo, facturación, correos y documentación en un mismo lugar para mover el negocio con más rapidez, menos errores y más control.</p>
             <ul className="landing-check-list">
               <li><FiCheckCircle aria-hidden="true" /> <span><strong>Emails y comunicaciones</strong> — Envía correos desde operaciones y mantén al cliente informado sin salir de la plataforma.</span></li>
               <li><FiCheckCircle aria-hidden="true" /> <span><strong>Firma digital</strong> — Presupuestos y facturas con validación y firma desde el mismo flujo de trabajo.</span></li>
               <li><FiCheckCircle aria-hidden="true" /> <span><strong>Decisiones más rápidas</strong> — Todo el historial de clientes, pedidos, tareas y facturación en una sola vista.</span></li>
             </ul>
           </div>
           <div className="landing-module-list">
             {modulos.map(({ titulo, texto, precio }, index) => (
               <div className="landing-module" key={titulo}>
                 <span>0{index + 1}</span>
                 <div><strong>{titulo}</strong><p>{texto}</p></div>
                 <div className="landing-module-price">{precio}</div>
               </div>
             ))}
           </div>
         </div>
        </section>

        <section id="demo" className="landing-section landing-demo-section">
          <div className="landing-container landing-demo-grid">
            <div className="landing-demo-copy">
              <p className="landing-eyebrow">Conoce Trix en tu contexto</p>
              <h2>Cuéntanos cómo trabajáis y te mostramos por dónde empezar.</h2>
              <p>En una demo breve revisamos tu caso: clientes, agenda, trabajo y facturación. Sin presentaciones genéricas ni compromiso.</p>
              <div className="landing-demo-note"><FiActivity aria-hidden="true" /><span><strong>Una demo útil empieza por tu operativa.</strong> Nos adaptamos a tu negocio y a cómo trabaja tu equipo.</span></div>
            </div>

            <form className="landing-form" onSubmit={handleSubmit}>
              <div className="landing-form-heading"><h2>Habla con un especialista</h2><p>Te ayudamos a ver cómo encaja Trix en tu negocio.</p></div>
              <div className="landing-form-grid">
                <label>Nombre<input required name="nombre" value={form.nombre} onChange={handleChange} autoComplete="name" placeholder="Tu nombre" /></label>
                <label>Email<input required type="email" name="email" value={form.email} onChange={handleChange} autoComplete="email" placeholder="nombre@empresa.es" /></label>
                <label>Teléfono<input name="telefono" value={form.telefono} onChange={handleChange} autoComplete="tel" placeholder="600 000 000" /></label>
                <label>Empresa<input name="empresa" value={form.empresa} onChange={handleChange} autoComplete="organization" placeholder="Nombre de tu negocio" /></label>
                <label className="landing-field-full">¿Qué necesitas?<select name="interes" value={form.interes} onChange={handleChange}><option value="demo">Quiero una demo</option><option value="seguimiento">Quiero que me contactéis</option><option value="informacion">Quiero más información</option></select></label>
                <label className="landing-field-full">Cuéntanos brevemente<textarea name="notas" value={form.notas} onChange={handleChange} placeholder="Por ejemplo: gestionar citas, coordinar turnos o mejorar el seguimiento de clientes." /></label>
              </div>
              <button className="landing-button" type="submit" disabled={enviando}>{enviando ? 'Enviando solicitud…' : 'Solicita tu demo'} <FiArrowRight aria-hidden="true" /></button>
              {estado.mensaje ? <p className={`landing-form-status ${estado.tipo}`} role="status" aria-live="polite">{estado.mensaje}</p> : null}
            </form>
          </div>
        </section>

        <section className="landing-section landing-pricing-section" aria-label="Paquetes de precios de Trix">
          <div className="landing-container">
            <div className="landing-section-heading landing-pricing-heading">
              <p className="landing-eyebrow">Paquetes y precios</p>
              <h2>Tu Pack, paso a paso</h2>
            </div>

            <div className="landing-pack-list">
              <div className="landing-pack-row">
                <div className="landing-pack-copy">
                  <h3>Pack 1: <span>Operación básica con control</span></h3>
                  <p>Clientes, agenda, presupuestos, facturación y primeros correos automáticos para empezar a digitalizar el negocio.</p>
                </div>
                <div className="landing-pack-price"><span>37</span><small>€/mes</small></div>
              </div>

              <div className="landing-pack-row">
                <div className="landing-pack-copy">
                  <h3>Pack 2: <span>Gestión profunda</span></h3>
                  <p>Incluye agenda, fichajes, vacaciones, tareas, almacén y firma digital para una operación más segura y eficiente.</p>
                </div>
                <div className="landing-pack-price"><span>75</span><small>€/mes</small></div>
              </div>

              <div className="landing-pack-row">
                <div className="landing-pack-copy">
                  <h3>Pack 3: <span>Automatización y crecimiento</span></h3>
                  <p>Incluye todo lo anterior más automatización avanzada, comunicaciones masivas, documentación y soporte para crecer sin fricción.</p>
                </div>
                <div className="landing-pack-price"><span>89</span><small>€/mes</small></div>
              </div>
            </div>

            <p className="landing-pack-summary"><FiCheckCircle aria-hidden="true" /> El sistema que combina gestión, comunicación, firma digital y automatización para que tu negocio avance sin caos.</p>          </div>
        </section>
      </main>

      <footer className="landing-footer">
        <div className="landing-container"><Link className="landing-brand" to="/"><span className="landing-brand-mark" aria-hidden="true">T</span><span className="landing-brand-word">TRIX</span></Link><p>Gestión conectada para negocios que quieren trabajar con más claridad.</p><Link to="/login">Acceso clientes</Link></div>
      </footer>
    </div>
  );
}
